import { BOT_INVITE_URL } from "../config";

export function addToDiscord() {
  // Open invite safely in a new tab (avoid Safari null-with-noopener bug)
  const url = BOT_INVITE_URL;
  const win = window.open(url, "_blank");
  if (win) { try { win.opener = null; } catch { console.log() } }
  else window.location.href = url; // popup-block fallback
}
